export default __webpack_public_path__ + "static/media/file-image_darkGray1.628dc638.svg";